import * as constant from "../../common/constant";

const GROUND_HANDLER_ROLE = constant.FUNC_ROLE_GROUND_HANDLER;
const EXISTING_QF_CUSTOMER_ROLE = constant.FUNC_ROLE_CURRENT_QF_CUSTOMER;
const OTHER_ROLE = constant.FUNC_ROLE_OTHER;
export {
    GROUND_HANDLER_ROLE,
    EXISTING_QF_CUSTOMER_ROLE,
    OTHER_ROLE
}